"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizerStatus = void 0;
const ChartContext_1 = require("../context/ChartContext");
const KeyModifierContext_1 = require("../context/KeyModifierContext");
function useResizerStatus(toolKey) {
    const { toolOptions: { selectedTool }, } = (0, ChartContext_1.useChartData)();
    const { shiftKey } = (0, KeyModifierContext_1.useKeyModifiers)();
    return !shiftKey && selectedTool === toolKey;
}
exports.useResizerStatus = useResizerStatus;
